export const tipoEstadosLotes = [
  { id: 1, nombre: 'Apartado' },
  { id: 2, nombre: 'Disponible' },
  { id: 3, nombre: 'Suspendido' },
  { id: 4, nombre: 'Vendido' },
  { id: -1, nombre: 'Eliminado' },
];